import type { CategoryNode } from 'tradera/backend/data/category-data';
import type { CategorySearchApiResponse } from 'tradera/state/services/types/webapi-discover-generated';

export function filterCategories(
    categories: CategoryNode[],
    filter: string,
    categoryResults?: CategorySearchApiResponse,
) {
    if (categories && filter.length > 0) {
        const matchingCategoryIds = (categoryResults?.categories || [])
            .map(({ leafCategories, parentCategories }) => [
                leafCategories?.map(({ categoryId }) => categoryId),
                parentCategories?.map(({ categoryId }) => categoryId),
            ])
            .flat()
            .flat();
        return categories
            .slice()
            .map((category) => {
                const children =
                    category.children
                        ?.slice()
                        .filter(
                            (child: CategoryNode) =>
                                child.name
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                matchingCategoryIds.includes(child.id),
                        ) || [];
                return {
                    ...category,
                    children,
                };
            })
            .filter((category) => category.children.length > 0);
    }
    return categories;
}
